(function () {
  "use strict";

  /**
   * @module datePickers
   */
  let datePickers = {};

  /**
   * Initialise any date picker components on the page
   *
   * @memberof module:datePickers
   */
  datePickers.init = () => {
    let $dateFields = document.querySelectorAll(
      ".qld__text-input--date-picker",
    );

    if ($dateFields.length > 0) {
      // Loop through each date field
      $dateFields.forEach(($dateField) => {
        const $container = $dateField.parentElement;
        const $datePickerBtn =
          $container.getElementsByClassName("calendar-toggle")[0];
        const $newDatePicker = document.createElement("duet-date-picker", {
          is: "duet-date-picker",
        });
        const dataset = { ...$dateField.dataset };
        let dateName = `${$dateField.name}`;
        console.log($dateField.name);
        dateName = dateName.includes("|")
          ? $dateField.name.split("|")[1]
          : $dateField.name;
        // Add required attribute to dataset object
        dataset.required = $dateField.required;

        // Set ID for new date picker
        $newDatePicker.setAttribute("identifier", `${dateName}-date-picker`);
        $container.append($newDatePicker);

        // Remove original date picker button, and hide the default field
        $datePickerBtn.remove();
        $dateField.classList.add("visuallyhidden");

        datePickerSettings($newDatePicker, dataset, $dateField);
      });
    }
  };

  // Add event handler to new date picker that updates the value for the default (hidden) field
  datePickers.addEventHandlers = ($newDatePicker, $originalDateField) => {
    const $datePicker = $newDatePicker;
    // When date is selected, set focus on datepicker, causing validation to run
    $datePicker.addEventListener("duetChange", function (e) {
      $originalDateField.value = e.detail.valueAsDate;
    });
  };

  // Setup datepicker with default values, and any the user have set on the element (data-max/min-date, data-default-date)
  const datePickerSettings = ($newDatePicker, options, $dateField) => {
    const dateFormat = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/; // dd/mm/yyyy
    const settings = options;
    const currentDate = new Date();
    const minDate = settings.hasOwnProperty("minDate")
      ? settings.minDate
      : `${currentDate.getFullYear() - 10}-01-01`;
    const maxDate = settings.hasOwnProperty("maxDate")
      ? settings.maxDate
      : `${currentDate.getFullYear() + 10}-01-01`;
    const defaultDate = settings.hasOwnProperty("defaultDate")
      ? settings.defaultDate
      : "";
    const shouldValidate = settings.hasOwnProperty("shouldValidate")
      ? settings.shouldValidate
      : false;
    const required = settings.required;
    const $label = document.querySelector(`label[for="${$dateField.id}"]`);

    // Associate label with visible date picker input
    $label.setAttribute("for", $newDatePicker.attributes[0].value);

    // Date adapter to enforce dd/mm/yyyy format
    $newDatePicker.dateAdapter = {
      parse(value = "", createDate) {
        const matches = value.match(dateFormat);
        if (matches) {
          return createDate(matches[3], matches[2], matches[1]);
        }
      },
      format(date) {
        return `${date.getDate().toString().padStart(2, 0)}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}`;
      },
    };
    // Needed to set this whole localization object up for the blank placeholder (can't set individual options without including all of them)
    $newDatePicker.localization = {
      buttonLabel: "Choose date",
      placeholder: "",
      selectedDateMessage: "Selected date is",
      prevMonthLabel: "Previous month",
      nextMonthLabel: "Next month",
      monthSelectLabel: "Month",
      yearSelectLabel: "Year",
      closeLabel: "Close window",
      calendarHeading: "Choose a date",
      dayNames: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthNamesShort: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };

    $newDatePicker.value = defaultDate; // Default date (format: yyyy-mm-dd)
    $newDatePicker.max = maxDate; // Max date able to be selected (format: yyyy-mm-dd)
    $newDatePicker.min = minDate; // Min date able to be selected (format: yyyy-mm-dd)
    $newDatePicker.required = required; // Required (format: Boolean)

    // Add jQuery validation rule for datepicker
    if (shouldValidate) {
      addValidationRules($newDatePicker);
    }

    // Set the value for new datepicker if the original field has a set/default value
    if ($dateField.value !== "") {
      $newDatePicker.value = $dateField.value;
    }

    // Add names to calendar popup select dropdowns (year/month)
    cleanUpDatepickerMarkup($newDatePicker);
    // Add event handlers
    datePickers.addEventHandlers($newDatePicker, $dateField);
  };

  // Clean up default markup for datepicker to make it more accessible
  const cleanUpDatepickerMarkup = ($newDatePicker) => {
    const $datePicker = $newDatePicker;
    const $hiddenInput = $newDatePicker.parentElement.getElementsByClassName(
      "qld__text-input--date-picker",
    )[0];
    const selectElements = $newDatePicker.querySelectorAll("select");
    const required = $datePicker.required;

    waitForDatePicker(`#${$hiddenInput.id}-date-picker`).then(() => {
      // Remove required attribute from hidden input (prevent validation triggering)
      if (required) {
        $hiddenInput.removeAttribute("required");
      }
      // Loop through each select element
      selectElements.forEach(function (select) {
        // Get the id of the select element
        let selectId = select.getAttribute("id");
        // Add name attribute to the select element containing its id
        select.setAttribute("name", selectId);
      });
    });
  };

  // Add validation rules, and clean up default markup for datepicker to make it more accessible
  const addValidationRules = ($newDatePicker) => {
    const $datePicker = $newDatePicker;
    const $hiddenInput = $newDatePicker.parentElement.getElementsByClassName(
      "qld__text-input--date-picker",
    )[0];
    const $form = $($newDatePicker).closest("form");

    if (!$.validator.methods.datepicker) {
      $.validator.addMethod(
        "datepicker",
        function (value, element) {
          return (
            value === "" ||
            /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(19|20)\d{2}$/.test(
              value,
            )
          );
        },
        "Please enter a valid date in the format dd/mm/yyyy",
      );
    }

    waitForDatePicker(`#${$hiddenInput.id}-date-picker`).then(() => {
      const $defaultInput =
        $newDatePicker.getElementsByClassName("duet-date__input")[0];
      const $calendarToggleBtn =
        $newDatePicker.getElementsByClassName("duet-date__toggle")[0];

      // Remove rules being applied to the dynamically created calendar toggle button via global validate rules
      $($calendarToggleBtn).rules("remove");

      // Add datepicker validation rule to the date picker input
      $($defaultInput).rules("add", {
        datepicker: true,
        messages: {
          datePicker: "Please enter a valid date in the format dd/mm/yyyy",
        },
      });
    });

    // When date is selected, set focus on datepicker, causing validation to run
    $datePicker.addEventListener("duetChange", function (e) {
      $datePicker.setFocus();
      console.log(e);
    });

    // On blur, validate the field
    $datePicker.addEventListener("duetBlur", function (e) {
      const $defaultInput =
        $newDatePicker.parentElement.getElementsByClassName(
          "duet-date__input",
        )[0];
      // If jquery validate is being used
      if ($form.data("validator")) {
        $($defaultInput).valid();
      }
    });
  };

  // Waits for Datepicker to initialise
  // No built in methods for the datepicker to achieve this
  const waitForDatePicker = (selector) => {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  };

  // Store datePickers object globally
  QLD.datePickers = datePickers;

  document.addEventListener("DOMContentLoaded", function () {
    QLD.datePickers.init();
  });
})();
